<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<template>
  <div class="table-box">
    <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />
    <div>
      <el-table
        style="width: 100%"
        v-loading="loading"
        row-key="questionnaireAnswerId"
        ref="recordList"
        :data="tableData"
        :stripe="false"
        :highlight-current-row="false"
        header-row-class-name="noBorder"
      >
        <!-- <el-table-column
          type="selection"
          width="55"
          row-key="questionnaireAnswerId"
          :reserve-selection="true"
        ></el-table-column> -->
        <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="title"
          label="问卷标题"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目"
        ></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" label="任务月度">
          <template slot-scope="scope">{{month}}</template>
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" align="center" label="填写时间">
          <template slot-scope="scope">{{scope.row.answerStartDt|transAllTime}}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="状态">
          <template slot-scope="scope">{{scope.row.auditGongyeStatus|transAuditStatus}}</template>
        </el-table-column>
         <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="check(scope.row)">查看</el-button> -->
            <el-button :disabled="scope.row.auditGongyeStatus !== 1" type="text" size="small" @click="approve(2,scope.row)">通过</el-button>
            <rejectComponent :disabled="scope.row.auditGongyeStatus !== 1" @withdraw="(item)=>approve(3,scope.row,0,item)"/>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { project,receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import OpenNewWin from '@/tools/openNewWin';
import searchbar from '@/components/Survey/searchbar'
import rejectComponent from '@/components/Task/components/reject.vue'
import approvalFlagMixins  from '@/Mixin/approvalFlagMixins';

export default {
  mixins: [pageInation, makeSure, taskRecordHandles,approvalFlagMixins],
  data() {
    return {
      ruleForm: {}, // 用户信息
      getList: project.questionnaireAnswerList, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        projectType: 7,
        statementId:this.$route.query.statementId

      },
      month: this.$route.query.month
    };
  },
  components: {
    dicSelect,
    searchbar,
    rejectComponent,

  },
  computed: {},
  methods: {
    check(item) {
      this.$router.push({
        name: 'yshSurveyRecordDetail',
        query: {
          questionnaireAnswerId: item.questionnaireAnswerId,
          id: this.$route.query.id,
          auditGongyeStatus:row.auditGongyeStatus,
          statementId: this.$route.query.statementId,
        }
      });
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.taskMonth) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(
          project.taskYxDyRecordDiaoyanPageListExportV2 + '?' + queryString
        );
      } else {
        this.$message.error('请选择条件');
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
</style>